import React from "react";
import Label from "components/general/Label"
import { arraysEqual } from 'helpers/utils'
import Accordion from 'react-bootstrap/Accordion';
import SjpExpandedDefault from "components/sports/sjp/helper/SjpExpandedDefault";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Competitor from "components/presentation/Competitor";


export const TableExpanded = (props) => {
    const { mirs_discipline,mirs_event_rsc } = useUrlFriendlyToParameters()
    const { row } = props;
    const { officials } = props;
    const { dataFirstRound } = props;

    let judges = []
    let f = 0
    officials.map((i) => {
        if(i?.function?.description === 'Judge')
        {
            judges[f++] = i
        }
    })

    let athlete1 = row?.teamAthletes?.find( or => or?.order === 1)
    let athlete2 = row?.teamAthletes?.find( or => or?.order === 2)
    let athlete3 = row?.teamAthletes?.find( or => or?.order === 3)
    let athlete4 = row?.teamAthletes?.find( or => or?.order === 4)

    let final = mirs_event_rsc.includes('FNL-0002')

    if(final)
    {
        let athlete1FirstRound = dataFirstRound?.teamAthletes?.find( or => or?.order === 1)
        let athlete2FirstRound = dataFirstRound?.teamAthletes?.find( or => or?.order === 2)
        let athlete3FirstRound = dataFirstRound?.teamAthletes?.find( or => or?.order === 3)
        let athlete4FirstRound = dataFirstRound?.teamAthletes?.find( or => or?.order === 4)
        return (
                <Accordion alwaysOpen>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header><Label data="HeaderRND_1" /></Accordion.Header>
                        <Accordion.Body>
                        <Accordion alwaysOpen>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        {athlete1FirstRound?.bib}
                                        &emsp;
                                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete1FirstRound?.athlete} />
                                        &emsp;
                                        {athlete1FirstRound?.athlete?.personGender?.description}
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <SjpExpandedDefault row={dataFirstRound} extendedResults={athlete1FirstRound?.extResults} judges={judges}/>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        {athlete2FirstRound?.bib}
                                        &emsp;
                                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete2FirstRound?.athlete} />
                                        &emsp;
                                        {athlete2FirstRound?.athlete?.personGender?.description}
                                    </Accordion.Header>
                                    <Accordion.Body>                            
                                        <SjpExpandedDefault row={dataFirstRound} extendedResults={athlete2FirstRound?.extResults} judges={judges}/>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        {athlete3FirstRound?.bib}
                                        &emsp;
                                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete3FirstRound?.athlete} />
                                        &emsp;
                                        {athlete3FirstRound?.athlete?.personGender?.description}
                                    </Accordion.Header>
                                    <Accordion.Body>                            
                                        <SjpExpandedDefault row={dataFirstRound} extendedResults={athlete3FirstRound?.extResults} judges={judges}/>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        {athlete4FirstRound?.bib}
                                        &emsp;
                                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete4FirstRound?.athlete} />
                                        &emsp;
                                        {athlete4FirstRound?.athlete?.personGender?.description}
                                    </Accordion.Header>
                                    <Accordion.Body>                            
                                        <SjpExpandedDefault row={dataFirstRound} extendedResults={athlete4FirstRound?.extResults} judges={judges}/>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header><Label data="HeaderFinalRound" /></Accordion.Header>
                        <Accordion.Body>                            
                            <Accordion alwaysOpen>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        {athlete1?.bib}
                                        &emsp;
                                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete1?.athlete} />
                                        &emsp;
                                        {athlete1?.athlete?.personGender?.description}
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <SjpExpandedDefault row={row} extendedResults={athlete1?.extResults} judges={judges}/>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        {athlete2?.bib}
                                        &emsp;
                                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete2?.athlete} />
                                        &emsp;
                                        {athlete2?.athlete?.personGender?.description}
                                    </Accordion.Header>
                                    <Accordion.Body>                            
                                        <SjpExpandedDefault row={row} extendedResults={athlete2?.extResults} judges={judges}/>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        {athlete3?.bib}
                                        &emsp;
                                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete3?.athlete} />
                                        &emsp;
                                        {athlete3?.athlete?.personGender?.description}
                                    </Accordion.Header>
                                    <Accordion.Body>                            
                                        <SjpExpandedDefault row={row} extendedResults={athlete3?.extResults} judges={judges}/>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        {athlete4?.bib}
                                        &emsp;
                                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete4?.athlete} />
                                        &emsp;
                                        {athlete4?.athlete?.personGender?.description}
                                    </Accordion.Header>
                                    <Accordion.Body>                            
                                        <SjpExpandedDefault row={row} extendedResults={athlete4?.extResults} judges={judges}/>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
        );
    }
    else
    {
        return (
            <Accordion alwaysOpen>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        {athlete1?.bib}
                        &emsp;
                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete1?.athlete} />
                        &emsp;
                        {athlete1?.athlete?.personGender?.description}
                    </Accordion.Header>
                    <Accordion.Body>
                        <SjpExpandedDefault row={row} extendedResults={athlete1?.extResults} judges={judges}/>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>
                        {athlete2?.bib}
                        &emsp;
                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete2?.athlete} />
                        &emsp;
                        {athlete2?.athlete?.personGender?.description}
                    </Accordion.Header>
                    <Accordion.Body>                            
                        <SjpExpandedDefault row={row} extendedResults={athlete2?.extResults} judges={judges}/>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>
                        {athlete3?.bib}
                        &emsp;
                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete3?.athlete} />
                        &emsp;
                        {athlete3?.athlete?.personGender?.description}
                    </Accordion.Header>
                    <Accordion.Body>                            
                        <SjpExpandedDefault row={row} extendedResults={athlete3?.extResults} judges={judges}/>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                    <Accordion.Header>
                        {athlete4?.bib}
                        &emsp;
                        <Competitor hidePicture={true} alwaysNoc={false} {...athlete4?.athlete} />
                        &emsp;
                        {athlete4?.athlete?.personGender?.description}
                    </Accordion.Header>
                    <Accordion.Body>                            
                        <SjpExpandedDefault row={row} extendedResults={athlete4?.extResults} judges={judges}/>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
    );
    }
};